import dayjs from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek'
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk'
import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'

import App, { FullPageLoad } from './App'
import AuthProvider from './authentication/AuthContext'
import './index.less'

dayjs.extend(isoWeek)
;(async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: `${process.env.REACT_APP_LAUNCHDARKLY_SDK_KEY}`,
    options: { privateAttributeNames: ['email', 'firstName', 'lastName', 'name'] },
  })

  ReactDOM.render(
    <React.StrictMode>
      <Router>
        <LDProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </LDProvider>
      </Router>
    </React.StrictMode>,
    document.getElementById('root')
  )
})()

ReactDOM.render(
  <React.StrictMode>
    <FullPageLoad />
  </React.StrictMode>,
  document.getElementById('root')
)
